import { Pipe, PipeTransform, NgModule, Directive, AfterViewInit, OnChanges, SimpleChanges, ElementRef, Input } from '@angular/core';
import * as moment from 'moment'
import { fromEvent, debounceTime, timer } from 'rxjs';

@Pipe({
  name: 'planDuration'
})
export class PlanDurationPipe implements PipeTransform {
  transform(duration) {
    switch (duration) {
      case '12M':
        return '12 months';
      case '6M':
        return '6 months';
      case '3M':
        return '3 months';
      case '1M':
        return '1 month';
      default:
        return 'From Initiation';
    }
  }
}

@Pipe({
  name: 'math'
})
export class mathPipe implements PipeTransform {
  transform(value: number) {
    return Math.abs(value)
  }
}

@Pipe({
  name: 'callCMPTickMark',
  pure: false
})
export class CallCMPTickMarkPipe implements PipeTransform {

  transform(callData: any): string {
    let remainingWidth = 0
    let currentPrice = callData?.currentPrice
    let purchasePrice = callData?.currentPriceFlag ? callData?.initialCurrentPrice : callData?.purchasePrice;
    let target = callData?.targetOne
    let stopLoss = callData?.stopLoss
    if (callData?.targetOneHitFlag || callData?.targetTwoHitFlag) {
      remainingWidth = 100
    } else if (callData?.stopLossHitFlag) {
      remainingWidth = 0
    } else if (currentPrice >= purchasePrice) {
      if (callData?.scriptType === 'BUY') {
        const diffToTrgt = target - purchasePrice
        const diffToEntry = currentPrice - purchasePrice
        const percent = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
        remainingWidth = 100 - percent
      } else {
        const diffToTrgt = stopLoss - purchasePrice
        const diffToEntry = currentPrice - purchasePrice
        const percent = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
        remainingWidth = 100 - percent
      }
    } else {
      if (callData?.scriptType === 'BUY') {
        const diffToTrgt = purchasePrice - stopLoss
        const diffToEntry = purchasePrice - currentPrice
        remainingWidth = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
      } else {
        const diffToTrgt = purchasePrice - target
        const diffToEntry = purchasePrice - currentPrice
        remainingWidth = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
      }
    }
    if (remainingWidth > 100) {
      remainingWidth = 100
    } else if (remainingWidth < 0) {
      remainingWidth = 0
    }
    return remainingWidth + '%';
  }
}

@Pipe({
  name: 'profitStreakMonth'
})
export class ProfitStreakMonthPipe implements PipeTransform {
  transform(month: number): string {
    switch (month) {
      case 1:
        return 'Jan'
      case 2:
        return 'Feb'
      case 3:
        return 'Mar'
      case 4:
        return 'Apr'
      case 5:
        return 'May'
      case 6:
        return 'Jun'
      case 7:
        return 'Jul'
      case 8:
        return 'Aug'
      case 9:
        return 'Sep'
      case 10:
        return 'Oct'
      case 11:
        return 'Nov'
      case 12:
        return 'Dec'
      default:
        return ''
    }
  }
}

@Directive({
  selector: '[CMPpos]',
})
export class CMPPositionDirective implements AfterViewInit, OnChanges {

  @Input() CMPpos: string = 'cmp'
  eleWidth: number = 0
  constructor(
    private el: ElementRef
  ) { }

  ngAfterViewInit(): void {
    timer(500).subscribe(() => {
      if(typeof window !== 'undefined'){
        this.eleWidth = this.el.nativeElement.clientWidth
        let leftPos = (this.eleWidth / 2) - 3
        let top = window.innerWidth > 767 ? '-40px' : '-30px'
        this.el.nativeElement.setAttribute('style', `top: ${this.CMPpos === 'entry' ? '13px' : top};left: ${leftPos > 0 ? '-' : ''}${leftPos}px;`)
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.CMPpos.previousValue !== changes.CMPpos.currentValue && typeof window !== 'undefined') {
      timer(500).subscribe(() => {
        this.eleWidth = this.el.nativeElement.clientWidth
        let leftPos = (this.eleWidth / 2) - 3
        let top = window.innerWidth > 767 ? '-40px' : '-30px'
        this.el.nativeElement.setAttribute('style', `top: ${this.CMPpos === 'entry' ? '13px' : top};left: ${leftPos > 0 ? '-' : ''}${leftPos}px;`)
      })
    }
  }

  // @HostListener('window:resize')
  positionCMP() {
    if(typeof window !== 'undefined'){
      fromEvent(window, 'resize').pipe(debounceTime(10)).subscribe((res)=>{
        timer(500).subscribe(() => {
          this.eleWidth = this.el.nativeElement.clientWidth
          let leftPos = (this.eleWidth / 2) - 3
          let top = window.innerWidth > 767 ? '-40px' : '-30px'
          this.el.nativeElement.setAttribute('style', `top: ${this.CMPpos === 'entry' ? '13px' : top};left: ${leftPos > 0 ? '-' : ''}${leftPos}px;`)
        })
      })
    }
  }
}

@Pipe({
  name: 'buyRange',
  pure: false
})
export class BuyRangePipe implements PipeTransform {
  transform(callData: any): boolean {
    if (callData && (callData._id || callData.id)) {
      if (callData?.scriptType === 'BUY') {
        return callData?.currentPrice >= callData?.minPurchasePriceRange && callData?.currentPrice <= callData?.maxPurchasePriceRange
      } else {
        return callData?.currentPrice >= callData?.maxPurchasePriceRange && callData?.currentPrice <= callData?.minPurchasePriceRange
      }
    } else {
      return false
    }
  }
}

@Pipe({
  name: 'profit',
  pure: false
})
export class CallProfitsPipe implements PipeTransform {
  transform(callData: any, isTraded: boolean = false): number {
    if (isTraded) {
      if (callData && callData?.call) {
        if (callData?.tradeQuantity === 0) {
          return callData?.tradeProfit
        } else {
          let avgPrice = callData?.totalTradeInvestments / callData?.totalTradeQuantity
          if (callData?.call.scriptType === 'BUY') {
            return (callData?.call?.currentPrice - avgPrice) * callData?.totalTradeQuantity
          } else {
            return (avgPrice - callData?.call?.currentPrice) * callData?.totalTradeQuantity
          }
        }
      } else {
        return 0
      }
    } else {
      let purchasePrice = callData?.currentPriceFlag ? callData?.initialCurrentPrice : callData?.purchasePrice
      if (callData && callData?._id) {
        if (callData?.status === 'COMPLETED') {
          if(callData.scriptType === 'BUY'){
          return callData?.currentPrice - purchasePrice
        }else{
          return purchasePrice - callData?.currentPrice
        }
        } else {
          if (callData?.scriptType === 'BUY') {
             return callData?.targetOne - purchasePrice
              // This is when we want profit according to lot size
              // callData?.lotSize ? ((callData?.currentPrice - purchasePrice)*callData?.lotSize) : callData?.currentPrice - purchasePrice
          } else {
            return purchasePrice - callData?.targetOne
            // This is when we want profit according to lot size
            // callData?.lotSize ? ((purchasePrice - callData?.currentPrice)* callData?.lotSize) : purchasePrice - callData?.currentPrice
          }
        }
      } else {
        return 0
      }
    }
  }
}

@Pipe({
  name: 'profitPercent',
  pure: false
})
export class CallProfitPercentPipe implements PipeTransform {
  transform(callData: any, isTraded: boolean = false): number {
    if (isTraded) {
      if (callData && callData?.call) {
        if (callData?.tradeQuantity === 0) {
          return (callData?.tradeProfit / callData?.totalTradeInvestments) * 100
        } else {
          let avgPrice = callData?.totalTradeInvestments / callData?.totalTradeQuantity
          if (callData?.call.scriptType === 'BUY') {
            return ((callData?.call.currentPrice - avgPrice) / avgPrice) * 100
          } else {
            return ((avgPrice - callData?.call.currentPrice) / avgPrice) * 100
          }
        }
      } else {
        return 0
      }
    } else {
      if (callData && callData._id) {
        if (callData?.status === 'COMPLETED') {
          if (callData?.scriptType === 'BUY') {
            // return callData.profitPercentage
           return Math.abs(((callData.currentPrice - callData.purchasePrice)/callData.purchasePrice)*100)
          }else{
            return Math.abs(((callData.purchasePrice - callData.currentPrice)/callData.purchasePrice)*100)
          }
        } else {
          let purchasePrice = callData?.currentPriceFlag ? callData?.initialCurrentPrice : callData?.purchasePrice          
          if (callData?.scriptType === 'BUY') {
            return ((callData?.targetOne - purchasePrice) / purchasePrice) * 100
          } else {
            return ((purchasePrice - callData?.targetOne) / purchasePrice) * 100
          }
        }
      } else {
        return 0
      }
    }
  }
}

@Pipe({
  name: 'callClosedOn'
})
export class CallClosedOnPipe implements PipeTransform {
  transform(callData: any) {
    const closureEnum = ['TARGET_ONE', 'TARGET_TWO', 'STOP_LOSS', 'DELETED', 'COMPLETED']
    if (callData && callData?.activities && callData?.activities.length) {
      const recentActivity = callData?.activities.find((x) => closureEnum.indexOf(x.status) > 0)
      if (recentActivity) {
        switch (recentActivity.status) {
          case 'TARGET_ONE' || 'TARGET_TWO':
            return 'Target Hit'
          case 'STOP_LOSS':
            return 'Stop Loss Hit'
          case 'DELETED':
            return 'Closed by Expert'
          default:
            return recentActivity.desc
        }
      } else {
        return 'Call is still active'
      }
    }
  }
}

@Pipe({
  name: 'activityData'
})
export class CallActivityDataPipe implements PipeTransform {
  transform(callData: any, status: string, type?: string) {
    if (callData && callData?.activities && callData?.activities.length) {
      return callData?.activities.find((x) => {
        if (x.status === status) {
          if (type) {
            if (x.type === type) {
              return x
            }
          } else {
            return x
          }
        }
      })
    }
  }
}

@Pipe({
  name: 'calculateDate'
})
export class CalculateDataPipe implements PipeTransform {
  today = new Date()
  transform(expiryDate: any) {
    let leftDate: number = 0
    let todayDate = moment(this.today.getTime())
    let expiry = moment(expiryDate)
    leftDate = expiry.diff(todayDate, 'days')
    return leftDate
  }
}

@Pipe({
  name: 'advisorExpired'
})
export class AdvisorExpired implements PipeTransform {
  today = new Date()

  transform(plan: any, type: string) {
    let expired: boolean = false;
    let willExpire: boolean = false

    let expiry = moment(plan.endDate);
    let todayDate = moment(this.today.getTime())
    let diffDays = expiry.diff(todayDate, 'days')
    if (diffDays > 0) {
      willExpire = true
    }

    if (diffDays <= 0 || (this.today.setHours(0, 0, 0, 0) === plan.expiryDate)) {
      expired = true
    }

    if (type === 'willExpire') {
      return willExpire
    } else if (type === 'expired') {
      return expired
    }
  }
}

@Pipe({ name: 'reverse' })
export class ReversePipe implements PipeTransform {
  transform(value: any[] = []) {
    if (value) {
      return value?.slice().reverse();
    }
  }
}

@Pipe({
  name: 'isBOorder'
})
export class IsBOorderPipe implements PipeTransform {

  transform(call: any, broker: string): boolean {
    if (call.label === "intraday") {
      if (broker === "five_paisa") {
        return false;
      } else if (broker === "aditya_birla") {
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}

@Pipe({
  name: 'tradeEntry'
})
export class TradeEntryPipe implements PipeTransform {
  transform(tradeData: any) {
    let remainingWidth = 0
    const entry = tradeData.call.currentPriceFlag ? tradeData.call.initialCurrentPrice : tradeData.call.purchasePrice
    let target = tradeData.call.targetOne
    let stopLoss = tradeData.call.stopLoss
    const tradeAvg = tradeData.tradeInvestments / tradeData.tradeQuantity
    if (tradeAvg >= entry) {
      if (tradeData.call.scriptType === 'BUY') {
        const diffToTrgt = target - entry
        const diffToEntry = tradeAvg - entry
        const percent = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
        remainingWidth = 100 - percent
      } else {
        const diffToSL = entry - stopLoss
        const diffToEntry = entry - tradeAvg
        const percent = ((diffToSL - diffToEntry) / diffToSL) * 100
        remainingWidth = 100 - percent
      }
    } else {
      if (tradeData.call.scriptType === 'BUY') {
        const diffToSL = entry - stopLoss
        const diffToEntry = entry - tradeAvg
        remainingWidth = ((diffToSL - diffToEntry) / diffToSL) * 100
      } else {
        const diffToTrgt = entry - target
        const diffToEntry = tradeAvg - entry
        remainingWidth = ((diffToTrgt - diffToEntry) / diffToTrgt) * 100
      }
    }
    if (remainingWidth > 100) {
      remainingWidth = 100
    } else if (remainingWidth < 0) {
      remainingWidth = 0
    }
    return remainingWidth + '%';
  }
}

@Pipe({
  name: 'myEntry',
})
export class MyEntryFlagPipe implements PipeTransform {
  transform(tradeData: any, type: string) {
    if (tradeData && tradeData.call) {
      const avg = tradeData.totalTradeInvestments / tradeData.totalTradeQuantity
      const purchasePrice = tradeData.call.currentPriceFlag ? tradeData.call.initialCurrentPrice : tradeData.call.purchasePrice
      if (type === 'SL') {
        return avg < purchasePrice
      } else {
        return avg >= purchasePrice
      }
    } else {
      return false
    }
  }
}


@Pipe({
  name: 'callCMP',
  pure: false
})
export class CallCMPPipe implements PipeTransform {
  transform(callData: any, type: string): string {
    if (callData && callData._id) {
      const cmp = callData?.currentPrice
      const purchasePrice = callData?.currentPriceFlag ? callData?.initialCurrentPrice : callData?.purchasePrice
      if (type === 'SL') {
        if (callData?.scriptType === 'BUY') {
          return cmp < purchasePrice ? 'block' : 'none'
        } else {
          return cmp >= purchasePrice ? 'block' : 'none'
        }

      } else {
        if (callData?.scriptType === 'BUY') {
          return cmp >= purchasePrice ? 'block' : 'none'
        } else {
          return cmp < purchasePrice ? 'block' : 'none'
        }
      }
    } else {
      return 'none'
    }
  }
}


@Pipe({
  name: 'specificActivity',
  pure: false
})
export class SpecificCallActivityPipe implements PipeTransform {
  transform(activities: any[], status?: string, type?: string) {
    if (activities && activities.length) {
      return activities.filter((x) => {
        if (status && type && x.status === status && x.type === type) {
          return x
        } else if (status && !type && x.status === status) {
          return x
        } else if (type && !status && x.type === type) {
          return x
        }
      })
    }
  }
}

@Pipe({
  name: 'callsCount'
})
export class CallsCountPipe implements PipeTransform {
  transform(count: any[], category: string): any {
    let callCount: any[];
    if (category === 'commodity') {
      callCount = count.filter((x) => x.callCategory === 'commodity_options' || x.callCategory === 'commodity_future')
    } else if (category === 'currency') {
      callCount = count.filter((x) => x.callCategory === 'currency_options' || x.callCategory === 'currency_future')
    } if (category === 'equity') {
      callCount = count.filter((x) => x.callCategory === 'options' || x.callCategory === 'future')
    } else {
      callCount = count.filter((x) => x.callCategory === category)
    }
    return callCount.length ? callCount.reduce((a, b) => a + b.count, 0) : 'No'
  }
}

@Pipe({
  name: 'totalTradedAmt'
})
export class TotalTradedAmtPipe implements PipeTransform {
  transform(allTrades: any[], type: 'entry' | 'exit'): number {
    if (allTrades.length) {
      if (type === 'entry') {
        let total = allTrades.reduce((a, b) => {
          if (b.scriptType === 'BUY') {
            return a + b.investment
          } else {
            return a + 0
          }
        }, 0)
        return parseInt(parseFloat(total.toString()).toFixed(2))
      } else {
        let total = allTrades.reduce((a, b) => {
          if (b.scriptType === 'SELL') {
            return a + b.investment
          } else {
            return a + 0
          }
        }, 0)
        return parseInt(parseFloat(total.toString()).toFixed(2))
      }
    } else {
      return parseInt(parseFloat("0").toFixed(2))
    }

  }
}

@Pipe({
  name: 'expectedReturns',
  pure: false
})
export class ExpectedReturnsPipe implements PipeTransform {
  transform(callData: any, type: 'Flat' | 'Percentage'): number {
    if (callData) {
      // const isFutureOrOptions = callData.callCategory === 'future' || callData.callCategory === 'options';
      // const lotMultiplier = isFutureOrOptions ? (callData.lotSize || 1) : 1;            
      if (callData.scriptType === 'BUY') {
        if (callData?.status === 'PENDING') {
          return type == 'Flat' ? (callData?.targetOne - callData?.purchasePrice) : ((callData?.targetOne - callData?.purchasePrice) / callData?.purchasePrice) * 100
          // return type == 'Flat' ? (callData?.targetOne - callData?.purchasePrice)* lotMultiplier : ((callData?.targetOne - callData?.purchasePrice) / callData?.purchasePrice) * 100 * lotMultiplier
        } else {
          return type == 'Flat' ? (callData?.targetOne - callData?.purchasePrice) : ((callData?.targetOne - callData?.purchasePrice) / callData?.purchasePrice) * 100
          // return type == 'Flat' ? (callData?.targetOne - callData?.currentPrice) * lotMultiplier : ((callData?.targetOne - callData?.currentPrice) / callData?.currentPrice) * 100 * lotMultiplier
        }
      }
      else {
        if (callData?.status === 'PENDING') {
          return type == 'Flat' ? (callData?.purchasePrice - callData?.targetOne) : ((callData?.purchasePrice - callData?.targetOne) / callData?.purchasePrice) * 100
          // return type == 'Flat' ? (callData?.purchasePrice - callData?.targetOne)* lotMultiplier : ((callData?.purchasePrice - callData?.targetOne) / callData?.purchasePrice) * 100 * lotMultiplier
        } else {
          return type == 'Flat' ? (callData?.purchasePrice - callData?.targetOne) : ((callData?.purchasePrice - callData?.targetOne) / callData?.purchasePrice) * 100
          // return type == 'Flat' ? (callData?.currentPrice - callData?.targetOne) * lotMultiplier : ((callData?.currentPrice - callData?.targetOne) / callData?.currentPrice) * 100 * lotMultiplier
        }
      }

    } else {
      return 0
    }
  }
}

@Pipe({
  name: 'newCall'
})
export class NewTagPipe implements PipeTransform {
  transform(item: any) {
    let today = new Date().setHours(0, 0, 0, 0)
    let createdDate = new Date(item?.createdAt).setHours(0, 0, 0, 0)
    if (today == createdDate) {
      return true;
    } else {
      return false;
    }
  }
}


@Pipe({
  name: 'brokerLoggedIn'
})
export class BrokerOptionPipe implements PipeTransform {
  transform(currentUser: any) {
    if (currentUser && currentUser.brokerageOptions.length) {
      let currentBroker = currentUser.brokerageOptions[0]
      switch (currentBroker) {
        case 'alice_blue':
          if (
            currentUser.aliceblue.accessToken &&
            currentUser.aliceblue.expires &&
            !(new Date(currentUser.aliceblue.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'trade_smart':
          if (
            currentUser.tradesmart.appId &&
            currentUser.tradesmart.passKey &&
            !(new Date(currentUser.tradesmart.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'master_trust':
          if (
            currentUser.mastertrust.accessToken &&
            currentUser.mastertrust.expires &&
            !(new Date(currentUser.mastertrust.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'five_paisa':
          if (
            currentUser.fivepaisa.accessToken &&
            currentUser.fivepaisa.expires &&
            !(new Date(currentUser.fivepaisa.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'zerodha':
          if (
            currentUser.zerodha.accessToken &&
            currentUser.zerodha.expires &&
            !(new Date(currentUser.zerodha.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'aditya_birla':
          if (
            currentUser.adityaBirla.accessToken &&
            currentUser.adityaBirla.expires &&
            !(new Date(currentUser.adityaBirla.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'bajaj_finserv':
          if (
            currentUser.bajajFinserv.accessToken &&
            currentUser.bajajFinserv.expires &&
            !(new Date(currentUser.bajajFinserv.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'angel_broking':
          if (
            currentUser.angelBroking.accessToken &&
            currentUser.angelBroking.expires &&
            !(new Date(currentUser.angelBroking.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'nuvama':
          if (
            currentUser.nuvama.accessToken &&
            currentUser.nuvama.expires &&
            !(new Date(currentUser.nuvama.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'klever_trade':
          if (
            currentUser.kleverTrade.accessToken &&
            currentUser.kleverTrade.expires &&
            !(new Date(currentUser.kleverTrade.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'finvasia':
          if (
            currentUser.finvasia.accessToken &&
            currentUser.finvasia.expires &&
            !(new Date(currentUser.finvasia.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'ZEBU':
          if (
            currentUser.zebu.accessToken &&
            currentUser.zebu.expires &&
            !(new Date(currentUser.zebu.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'upstox':
          if (
            currentUser.upstox.accessToken &&
            currentUser.upstox.expires &&
            !(new Date(currentUser.upstox.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        case 'paytm':
          if (
            currentUser.paytm.accessToken &&
            currentUser.paytm.expires &&
            !(new Date(currentUser.paytm.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
         case 'ventura':
          if (
            currentUser.ventura.accessToken &&
            currentUser.ventura.expires &&
            !(new Date(currentUser.ventura.expires) < new Date())
          ) {
            return true
          } else {
            return false
          }
        default:
          return false
      }
    } else {
      return false
    }
  }
}

@Pipe({
  name: 'brokerLiveFeed'
})
export class BrokerLiveFeedPipe implements PipeTransform {
  transform(liveFeed: any[], broker) {
    if (liveFeed && broker) {
      let feed = liveFeed.filter((x) => x.feedTo === broker.toUpperCase())
      if (feed) {
        return feed[0]?.isDelay;
      }
    } else {
      return null;
    }
  }
}
@Pipe({
  name: 'holdingsCalculation',
  pure: false
})
export class HoldingsCalculation implements PipeTransform {
  transform(item: any, type: 'pl' | 'pl%') {
    if (type == 'pl') {      
      return item.qty >= 0 ? item.qty * (item.currentPrice - item.avgPrice) :  Math.abs(item.qty) * (item.avgPrice - item.currentPrice);
    }
    else {
      return item.qty >= 0 ? ((item.qty * (item.currentPrice - item.avgPrice)) / item.actualInvestment) * 100 : ((Math.abs(item.qty) * (item.avgPrice - item.currentPrice)) / Math.abs(item.actualInvestment)) * 100;
    }
  }
}
@Pipe({
  name: 'totalInvestmentCalculation',
  pure: false
})
export class TotalInvestmentCalculation implements PipeTransform {
  transform(items: any) {
    let totalInvestment = 0;
    items.forEach((item) => {
      totalInvestment += item.avgPrice * Math.abs(item.qty)
    })
    return totalInvestment
  }
}
@Pipe({
  name: 'totalCurrentPriceCalculation',
  pure: false
})
export class TotalCurrentPriceCalculation implements PipeTransform {
  transform(items: any) {
    let totalCMP = 0;
    items.forEach((item) => {
      if (item.currentPrice) {
        totalCMP += item.currentPrice * Math.abs(item.qty)
      }
    })
    return totalCMP
  }
}
@Pipe({
  name: 'totalPLCalculation',
  pure: false
})
export class TotalPLCalculation implements PipeTransform {
  transform(items: any) {
    let totalPL = 0;
    items.forEach((item) => {
      if (item.currentPrice) {
        totalPL += item.qty >=0 ? ((item.currentPrice - item.avgPrice) * item.qty) : ((item.avgPrice - item.currentPrice) * Math.abs(item.qty))
      }
    })
    return totalPL
  }
}

@Pipe({
  name: 'currentBroker'
})
export class CurrentBrokerPipe implements PipeTransform {
  transform(brokerlist: any[], broker: string) {    
    return brokerlist.find((x) => x.code === broker)
  }
}
@Pipe({
  name: 'daysBetween'
})
export class DaysBetweenPipe implements PipeTransform {

  transform(entryDate: Date | string, exitDate: Date | string): number | null {
    if (!entryDate || !exitDate) {
      return null;
    }

    const entry = new Date(entryDate);
    const exit = new Date(exitDate);

    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round(Math.abs((exit.getTime() - entry.getTime()) / oneDay));

    return diffDays;
  }

}

@Pipe({
  name: 'unrealizedProfit'
})
export class UnRealizedProfitPipe implements PipeTransform {

  transform(items:any, type: 'pl' | 'pl%'): number | null {
    if(!items.length){
      return 0
    }else{
      let totalInvestment = 0;
      let currentInvestment = 0;
      items.forEach((item:any)=>{
        totalInvestment += item.tradeEntryPrice * item.tradeQuantity
        currentInvestment += item.currentPrice * item.tradeQuantity
      });      
      let profitLoss = currentInvestment - totalInvestment;
      if(type === 'pl'){
        return profitLoss ? profitLoss : 0
      }else{
        return (profitLoss/totalInvestment)*100 ?  (profitLoss/totalInvestment)*100 : 0
      }
    }
  }

}


@NgModule({
  declarations: [
    CallCMPTickMarkPipe,
    PlanDurationPipe,
    ProfitStreakMonthPipe,
    CMPPositionDirective,
    BuyRangePipe,
    CallProfitsPipe,
    CallProfitPercentPipe,
    CallClosedOnPipe,
    CallActivityDataPipe,
    CalculateDataPipe,
    AdvisorExpired,
    ReversePipe,
    IsBOorderPipe,
    TradeEntryPipe,
    SpecificCallActivityPipe,
    CallsCountPipe,
    MyEntryFlagPipe,
    CallCMPPipe,
    TotalTradedAmtPipe,
    ExpectedReturnsPipe,
    NewTagPipe,
    BrokerOptionPipe,
    BrokerLiveFeedPipe,
    NewTagPipe,
    HoldingsCalculation,
    mathPipe,
    TotalInvestmentCalculation,
    TotalPLCalculation,
    TotalCurrentPriceCalculation,
    CurrentBrokerPipe,
    DaysBetweenPipe,
    UnRealizedProfitPipe
  ],
  exports: [
    CallCMPTickMarkPipe,
    PlanDurationPipe,
    ProfitStreakMonthPipe,
    CMPPositionDirective,
    BuyRangePipe,
    CallProfitsPipe,
    CallProfitPercentPipe,
    CallClosedOnPipe,
    CallActivityDataPipe,
    CalculateDataPipe,
    AdvisorExpired,
    ReversePipe,
    IsBOorderPipe,
    TradeEntryPipe,
    SpecificCallActivityPipe,
    CallsCountPipe,
    MyEntryFlagPipe,
    CallCMPPipe,
    TotalTradedAmtPipe,
    ExpectedReturnsPipe,
    NewTagPipe,
    BrokerOptionPipe,
    BrokerLiveFeedPipe,
    NewTagPipe,
    HoldingsCalculation,
    mathPipe,
    TotalInvestmentCalculation,
    TotalPLCalculation,
    TotalCurrentPriceCalculation,
    CurrentBrokerPipe,
    DaysBetweenPipe,
    UnRealizedProfitPipe
  ]
})
export class TradingPipeModule { }
